import { Injectable } from '@angular/core';
import { CoreService } from '../../../core/core.service';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';

@Injectable()
export class ArmccmService {
private reportApiUrl = environment.reportApiUrl;

constructor(private coreService: CoreService) { }
UpdateSawwInfo(awards) {
return this.coreService.post('Forms/saveEnergyEfficiency/', awards);

}

 getReportUrl(relativeUrl: string) {
  return this.reportApiUrl + relativeUrl;
  }


SaveArmccm(postdata) {
    return this.coreService.post('Forms/SaveArmccm/', postdata);
  }


OpenWindowWithPostRequest(url, params) {
    const winName = 'view';
    const winURL = url;

    const form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', winURL);
    form.setAttribute('target', winName);
    for (const i in params) {
      if (params.hasOwnProperty(i)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
      }
    }
    document.body.appendChild(form);
    window.open('', winName);
    form.target = winName;
    form.submit();
    document.body.removeChild(form);
  }

}

